import { isValidHTTPUrl } from "../../../utils/url-utils";
import { OrgSamlSettingType } from "./org-saml-setting";

type OrgSamlSettingValidationError = {
  samlSlug?: string;
  idProviderEntityId?: string;
  idProviderSsoUrl?: string;
  certificateFileKey?: string;
};

export class OrgSamlSettingValidator {
  constructor(private setting: OrgSamlSettingType | null) {}

  isValid(): boolean {
    return Object.values(this.validationError).every((v) => v === undefined);
  }

  private get validationError(): OrgSamlSettingValidationError {
    return {
      samlSlug: this.samlSlug,
      idProviderEntityId: this.idProviderEntityId,
      idProviderSsoUrl: this.idProviderSsoUrl,
      certificateFileKey: this.certificateFileKey,
    };
  }

  get samlSlug(): string | undefined {
    if (!this.setting) {
      return undefined;
    }
    if (this.setting.samlSlug.length === 0) {
      return "サービスプロバイダ識別子を入力してください。";
    }
    if (!this.setting.samlSlug.match(/^[a-zA-Z0-9-]+$/)) {
      return "半角英数字とハイフンのみで入力してください。";
    }
    return undefined;
  }

  get idProviderEntityId(): string | undefined {
    if (!this.setting) {
      return undefined;
    }
    if (this.setting.idProviderEntityId.length === 0) {
      return "IDプロバイダのEntity IDを入力してください。";
    }
    return undefined;
  }

  get idProviderSsoUrl(): string | undefined {
    if (!this.setting) {
      return undefined;
    }
    if (this.setting.idProviderSsoUrl.length === 0) {
      return "IDプロバイダのSingle Sign On URLを入力してください。";
    }
    if (!isValidHTTPUrl(this.setting.idProviderSsoUrl)) {
      return "有効なURLを入力してください。";
    }
    return undefined;
  }

  get certificateFileKey(): string | undefined {
    if (!this.setting) {
      return undefined;
    }
    if (this.setting.certificateFileKey.length === 0) {
      return "X509証明書ファイルをアップロードしてください。";
    }
    return undefined;
  }
}
